import {OPEN_MSG, CLOSE_MSG} from './msgTypes';
export function closeMsg() {
   return {
      type: CLOSE_MSG
   };
}

export function openMsg(mensaje, accionAceptar, aceptarLabel) {
   return {
      type: OPEN_MSG,
      payload: {
         mensaje,
         accionAceptar,
         aceptarLabel
      }
   };
}
